module.exports = __webpack_public_path__ + "static/akadi-symbol-DND3_FnP-c9f2ebc0926797e34ae64003434079f3.png";